<template>
    <div id="funcionario-listagem">
        <!-- <my-tour v-if="itens.length > 0" :steps="steps" name="steps-parceiros"></my-tour> -->
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina class="mb-2" titulo="Relatório de empresas parceiras" />

                <div class="row">
                    <div class="col m12">
                        <div class="card-panel">
                            <div class="flex-row bottom-xs">
                                <div class="col-xs-12 col-md-2">
                                    <label for="empresa_tipo_id">Selecione a empresa</label>
                                    <select class="browser-default" v-model="filtro.id_empresa" @change="pesquisar()">
                                        <option id="empresa_tipo_id" v-for="empresa in empresas" v-bind:value="empresa.empresa_id">{{empresa.empresa_nome_fantasia}}</option>
                                    </select>
                                </div>
                                <template v-if="showDate">
                                    <div class="col-xs-12 col-md-2">
                                        <label>Data Início</label>
                                        <date-picker style="width: 100%" :value="filtro.data_ini" :default-value="data_ini" v-model="filtro.data_ini" format="DD/MM/YYYY" @change="pesquisar()" input-class="m-0" />
                                    </div>
                                    <div class="col-xs-12 col-md-2">
                                        <label>Data Final</label>
                                        <date-picker style="width: 100%" :default-value="data_fim" v-model="filtro.data_fim" format="DD/MM/YYYY" @change="pesquisar()" input-class="m-0" />
                                    </div>
                                </template>
                                <div class="col-xs-12 col-md">
                                    <i v-if="showDate"  class="material-icons md-32 grey-text clear asc" :class="filtro.order == 'asc' ? 'active': ''"  @click="setOrder('asc')">filter_list</i>
                                    <i v-if="showDate"  class="material-icons md-32 grey-text clear desc" :class="filtro.order == 'desc' ? 'active': ''"  @click="setOrder('desc')">filter_list</i>
                                    <span class="ml-1 info" v-if="showDate"  v-html="fraseOrder"></span>
                                </div>

                                <div class="col-xs-12 col-md-2">
                                    <button
                                    v-if="showDate"
                                    class="btn waves-effect waves-light right hide-on-med-and-down btn-default"
                                    style="margin-top: 12px"
                                    @click="downloadPDF"
                                >
                                    <i class="material-icons left">file_download</i>
                                    Exportar
                                </button>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="col s12 m12 l12" v-if="itens.length">
                        <div class="card-panel" style="text-transform: uppercase;">
                            <grid
                                :data="paginationConfig.itens"
                                :columns="gridColumns"
                                :filter-key="searchQuery"
                                :showOrder="false"
                            >
                            </grid>
                            <Pagination v-if="gridData.length > 0" :perPage="paginationConfig.perPage" :qty="paginationConfig.qty" :setCurrent="setCurrent" :current="paginationConfig.current" />
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>

    </div>
</template>

<style lang="scss">
@import './Desempenho.scss';
@import "@/../../static/assets/css/custom/flex.css";
</style>
<script>
    import Grid from '@/components/common/Grid';
    import { post, get } from '@/helpers/api';
    import Message from '@/helpers/message';
    import TituloPagina from '@/components/common/TituloPagina';
    import Pagination from '@/components/common/Pagination/Pagination';
    import ListHelper from '@/helpers/list';
    import MyTour from '@/components/common/MyTour.vue';
    import { EMPRESA_PARCEIRA } from '@/constants/empresaTipo';
    import { DONO, GERENTE, ESPECIALISTA, MASTER } from '@/constants/funcionarioCargo.js';
    import TourHelper from '@/helpers/tour';
    import Card from '@/components/common/Card/Card';
    import Auth from '@/store/auth';
    import getPalavra from '@/helpers/language';
    import
    {
        isMultiEmpresa
    }
    from '@/environment';
    import { download } from '@/pdf/EmpresasParceiras';

    // import DATEPICKER  from '@/constants/datepicker';

    export default {
        components: {
            Grid,
            Card,
            TituloPagina,
            Pagination,
            MyTour
        },
        data: () => ({
            paginationConfig: {
                perPage: 20,
                qty: 1,
                current: 1,
                itens: []
            },
            showDate: false,
            itens: [],
            itensDefault: [],
            searchQuery: '',
            gridColumns: [],
            gridData: [],
            fraseOrder: '',
            empresas: [],
            filtro:{
                data_ini: moment().subtract(3, 'months').toDate(),
                data_fim: moment().toDate(),
                order: 'desc',
                id_empresa: null,
            },
        }),
        created() {
            // verifica se pode acessar componente
            if (Auth.getCargoUsuario() !== MASTER && [DONO, ESPECIALISTA].indexOf(Auth.getCargoUsuario()) === -1) {
                this.$router.push('/sempermissao');
            }
             this.setFraseOrder();

            this.gridColumns = ['id', 'Funcionário', 'Efetivados', 'Negativados', 'Total'];

            this.steps = TourHelper.createSteps(this.steps);
        },


        computed: {

            data_ini() {
                return this.toDate(this.filtro.data_ini);
            },
            data_fim() {
                return this.toDate(this.filtro.data_fim);
            }
        },

        watch: {
            'filtro.id_empresa'(newValue){
                this.showDate = newValue != '';
            },
            'filtro.order'(){
                this.pesquisar();
            },
            'paginationConfig.current'(newValue, oldValue){
                if(newValue != oldValue){
                    this.pesquisar();
                }
            },
            'filtro.funcionario'(){
                this.funcionariosFiltered = [];
                const func = this.filtro.funcionario;
                if(func){
                    this.funcionariosFiltered = this.funcionarios.filter(resp => {
                        return resp.pessoa_nome.toLowerCase().includes(func.toLowerCase())
                        });
                }
            },
        },
        mounted() {
            // const configPick = DATEPICKER;


            let self = this;

            this.showLoading();

            get('empresa').then(function (response) {
                /* console.log('REPONSE: ', response) */
                self.empresas  = response.data.result.data.data.filter(empresa => empresa.empresa_tipo_id == EMPRESA_PARCEIRA);
                self.showLoading(false);
            });
        },
        methods: {


            toDate(string_date)
            {
                const value = moment(string_date, 'DD/MM/YYYY');
                return value.isValid() ? value.toDate() : null;
            },

            setCurrent(current){
                this.paginationConfig.current = current;
            },
            isValidDate(dt){
               return moment(dt, 'DD/MM/YYYY').isValid();
            },

            prepareParams(){

                let newParams = {
                    page_qtd: this.paginationConfig.perPage,
                    page_ini: this.paginationConfig.current,
                    ...this.filtro
                };

                if(this.isValidDate(this.filtro.data_ini) && this.isValidDate(this.filtro.data_fim)){
                    newParams.data_ini = moment(this.filtro.data_ini, 'DD/MM/YYYY').format('YYYY-MM-DD');
                    newParams.data_fim = moment(this.filtro.data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
                return  newParams;
            },

            prepareData(items = []){
                const data = [];
                 items.forEach((obj) => {
                        data.push({
                            id: obj.id_funcionario,
                            Funcionário: obj.nome_funcionario,
                            Efetivados: obj.leads_efetivados,
                            Negativados: obj.leads_negativados,
                            Total: obj.total
                        });
                    });

                return data;
            },
            pesquisar(){

                this.showLoading(true);

                const self = this;

                post('grafico/relatorio-empresa-parceira',{...this.prepareParams()}).then(function (response) {
                    self.itens = response.data.result.data.itens;
                    // debugger;
                    self.gridData = self.prepareData(self.itens);
                    self.showLoading(false);
                    self.paginationConfig.qty   = response.data.result.data.total;
                    self.paginationConfig.itens = self.gridData;

                });
            },
            downloadPDF(){
                this.showLoading();
                const self = this;
                const data_ini = moment(self.filtro.data_ini, 'DD/MM/YYYY').format('YYYY-MM-DD');
                const data_fim = moment(self.filtro.data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD');
                // debugger;
                post('grafico/relatorio-empresa-parceira',{id_empresa: this.filtro.id_empresa, data_fim, data_ini, order: this.filtro.order}).then(function (response) {
                    const itens = self.prepareData(response.data.result.data.itens);
                    self.showLoading(false);
                download({
                    itens: itens,
                    name: self.empresas.filter(em => em.empresa_id == self.filtro.id_empresa)[0].empresa_nome_fantasia,
                    }, {
                    fileName: `relatorio_empresa_parceira_${self.filtro.data_ini}_${self.filtro.data_fim}`,
                    subTitle: `Data: ${self.filtro.data_ini} a ${self.filtro.data_fim}, Ordenação decrescente pelos corretores com mais leads efetivados`,
                });
                    self.showLoading(false);
                });
            },
 ///
            setFraseOrder(){
                if(this.filtro.order == 'asc'){
                    this.fraseOrder = `Corretores com <b>menos</b> efetivados`;
                }else if(this.filtro.order == 'desc'){
                    this.fraseOrder = 'Corretores com <b>mais</b> efetivados';
                }
            },
             setOrder(order){
                if(this.filtro.order != order){
                    this.filtro.order = order;
                    this.filtro = Object.assign({}, this.filtro, { order });
                    this.setFraseOrder();
                }
            },
            onDateSelected(newValue, field) {
                const tempFiltro = {};
                tempFiltro[field] = newValue;
                this.filtro = Object.assign({}, this.filtro, tempFiltro);
                this.pesquisar();
            },
            showLoading(show = true){
                this.$parent.$emit('showLoading', show);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/relatorios/Parceiro.vue